import CaptchaFactory from './captcha/CaptchaFactory';

export default class ChCaptcha {
    constructor(element, captchaCallback, sitekey, captchaType = 'recaptcha') {
        this.element = element;
        this.captchaCallback = captchaCallback;
        this.sitekey = sitekey;
        this.captchaType = captchaType;
        this.provider = null;
        
        // For backward compatibility
        this.captcha_validated = false;
        this.token = null;
        this.ch_token = null;
    }

    async injectScripts(slug, ch_token) {
        this.slug = slug;
        this.ch_token = ch_token;
        
        // Create the appropriate captcha provider with proper configuration
        const config = {
            sitekey: this.sitekey
        };
        
        // Add Altcha-specific configuration
        if (this.captchaType === 'altcha') {
            // Get challengeUrl from environment variable
            config.challengeUrl = process.env.ALTCHA_CHALLENGE_URL;
        }
        
        this.provider = CaptchaFactory.create(
            this.captchaType,
            this.element,
            this.verifyCaptcha.bind(this),
            config
        );
        
        // Initialize the provider
        await this.provider.initialize(slug, ch_token);
    }

    // This method is called by window.ChCaptcha.onloadCallback in the existing implementation
    onloadCallback() {
        if (this.provider && this.provider.render) {
            this.provider.render();
        }
    }

    async resetCaptcha() {
        // Only reset if not already validated
        if (!this.captcha_validated) {
            if (this.provider) {
                await this.provider.reset();
            }
            
            this.captcha_validated = false;
            this.token = null;
        }
    }

    async verifyCaptcha(response) {
        this.captcha_validated = true;
        this.token = response;
        
        if (this.captchaCallback) {
            await this.captchaCallback(response);
        }
    }

    // Getter methods for backward compatibility
    getCaptchaValidated() {
        return this.provider ? this.provider.isValid() : this.captcha_validated;
    }

    getToken() {
        return this.provider ? this.provider.getToken() : this.token;
    }
}